import { render, staticRenderFns } from "./UploadOSSFile.vue?vue&type=template&id=a1cebe8a&scoped=true&"
import script from "./UploadOSSFile.vue?vue&type=script&lang=js&"
export * from "./UploadOSSFile.vue?vue&type=script&lang=js&"
import style0 from "./UploadOSSFile.vue?vue&type=style&index=0&id=a1cebe8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cebe8a",
  null
  
)

export default component.exports